<template>
    <div class="AlarmContactSearch">
        <Row :gutter="4">
            <!-- 选择公司 -->
            <div v-if="company==1">
              <Col span="4" >
                  <Select v-model="companyId" filterable :placeholder="$t('alarm_contact.selectByCompany')" :transfer="true" @on-change="searchCompany">
                      <Option value=" " selected>{{$t('alarm_contact.allType')}}</Option>
                      <Option :value="item.id" v-for="item in companyList" :key="item.id">{{item.name}}</Option>
                  </Select>
              </Col>
            </div>
            <Col span="4">
                <Input search v-model="alarmContactSearchKey" :placeholder="$t('alarm_contact.selectByName')" @on-search="searchAlarmContact()"/>
            </Col>
            <Col span="4">
                <add-alarm-contact></add-alarm-contact>
            </Col>
        </Row>
    </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../utils/cookieUtil.js'
    import AddAlarmContact from '../alarm_contact/AddAlarmContact'
    import TableAlarmContact from '../alarm_contact/TableAlarmContact'
    var tableAlarmContact = TableAlarmContact;
    export default {
        name: 'AlarmContactSearch',
        components: {
            AddAlarmContact
        },
        data () {
            return {
                company: getCookie(global.companyId),
                companyId: '',
                companyList: [],
                alarmContactSearchKey:'',
                alarmContactSearchName:''
            }
        },
        mounted: function(){
            if (this.company == 1) {
                this.getCompanyDropDownBox();
            }
        },
        methods: {
            // 获取公司下拉框
            getCompanyDropDownBox: function(){
               this.$api.company.getCompanyDropDownBox("userName",getCookie(global.cookieName))
                 .then(res => {
                     this.companyList = res.data;
                 });
            },
            // 按公司搜索
            searchCompany: function(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('companyId', this.companyId);
                tableAlarmContact.methods.showAll();
            },
            searchAlarmContact: function(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('alarmContactSearchName', this.alarmContactSearchKey);
                tableAlarmContact.methods.showAll();
            }
            
        }
    }
</script>
<style scoped>
    .AlarmContactSearch
    {
        height: 51px;
    }
</style>



// WEBPACK FOOTER //
// src/components/alarm_contact/alarm_contact/AlarmContactSearch.vue